import { UseControllerProps } from 'react-hook-form/dist/types/controller';

import { FormBuilderInputValidationRuleStoryblok } from '../FormBuilderInput/FormBuilderInput.types';

/**
 * Creates an object with React Hook Form's validation rules
 * that can be then passed to Controller's component `rules` prop.
 * */
export function createRHFControllerValidationRules(
  validationRules: FormBuilderInputValidationRuleStoryblok[]
): UseControllerProps['rules'] {
  return (
    validationRules?.reduce((rules, curr) => {
      if (curr.type === 'required') {
        return {
          ...rules,
          required: {
            value: true,
            message: curr.errorMessage || `This field is required`,
          },
        };
      }

      if (curr.type === 'minLength' && Number(curr.value)) {
        return {
          ...rules,
          minLength: {
            value: Number(curr.value),
            message:
              curr.errorMessage || `Should be at least ${Number(curr.value)} characters long`,
          },
        };
      }

      if (curr.type === 'maxLength' && Number(curr.value)) {
        return {
          ...rules,
          maxLength: {
            value: Number(curr.value),
            message:
              curr.errorMessage || `Should be less than ${Number(curr.value)} characters long`,
          },
        };
      }

      return rules;
    }, {}) || []
  );
}
